import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { deleteIngredient } from '../../../redux/slices/admin/ingredientsSlice';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const IngredientsTable = ({ onEdit, handlePageChange }) => {
  const dispatch = useDispatch();
  const { ingredients, currentIngredientPage, totalIngredientPages } = useSelector((state) => state.admin_ingredients);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) {
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this ingredient?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteIngredient(id))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
        <table className="table table-striped table-users table-alex printarea">
          <thead>
            <tr>
              <th>Name</th>
              <th>Protein</th>
              <th>Carbs</th>
              <th>Fat</th>
              <th className="noprint">Action</th>
            </tr>
          </thead>
          <tbody>
            {ingredients && ingredients.length > 0 ? (
              ingredients.map((ingredient) => (
                <tr key={ingredient.id}>
                  <td>
                    <div className="text-start">{ingredient.ingredient_name}</div>
                  </td>
                  <td>{ingredient.protein_per_unit}/{ingredient.unit}</td>
                  <td>{ingredient.carb_per_unit}/{ingredient.unit}</td>
                  <td>{ingredient.fat_per_unit}/{ingredient.unit}</td>
                  <td className="noprint">
                    <div className="text-center position-relative" ref={dropdownRef}>
                      <button 
                        type="button" 
                        className="bg-transparent border-0 p-0 btn-vert-dots" 
                        onClick={(e) => toggleDropdown(ingredient.id, e)}
                      >
                        <img src={optionsIcon} alt="Options" />
                      </button>
                      {activeDropdown === ingredient.id && (
                        <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                          <li>
                            <a className="dropdown-item" onClick={() => onEdit(ingredient)}>
                              <img src={editIcon} alt="Edit" /> Edit
                            </a>
                          </li>

                           {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(ingredient.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                           )}
                           
                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">No ingredients found.</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>

      <Pagination 
        currentPage={currentIngredientPage} 
        totalPages={totalIngredientPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default IngredientsTable;